import { OpenEndedQuestionConfig } from '@hyper-inferno/open-ended-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  QuestionAnswerObject,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

export class OpenEndedHandler
  implements QuestionHandler<OpenEndedQuestionConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    return el.config;
  }

  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    const key = el.name;
    return response[key] ?? ''; // returns number
  }
}
